module.exports = __webpack_public_path__ + "imgs/pinterest-color.192f8ea4aab06a2fc0b2088325e261a5.svg";